// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck.ck-editor__editable_inline {
  border: none !important;
  min-height: 150px;
  height: 100%;
  box-shadow: none !important;
}
.ck.ck-editor {
  height: 100%;
}
.ck .ck-editor__main {
  height: 100%;
}
.ck.ck-toolbar {
  border: none !important;
}
.tox-tinymce {
  border: none !important;
  border-bottom: 1px rgb(197, 197, 197) solid !important;
  /* min-height: 200px !important; */
}
.tox-notification--warning {display: none !important;}
.tox .tox-menu {z-index: 1200 !important;}`, "",{"version":3,"sources":["webpack://./src/app/routes/mail/Components/ComposeMail/custom.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,kCAAkC;AACpC;AACA,4BAA4B,wBAAwB,CAAC;AACrD,gBAAgB,wBAAwB,CAAC","sourcesContent":[".ck.ck-editor__editable_inline {\n  border: none !important;\n  min-height: 150px;\n  height: 100%;\n  box-shadow: none !important;\n}\n.ck.ck-editor {\n  height: 100%;\n}\n.ck .ck-editor__main {\n  height: 100%;\n}\n.ck.ck-toolbar {\n  border: none !important;\n}\n.tox-tinymce {\n  border: none !important;\n  border-bottom: 1px rgb(197, 197, 197) solid !important;\n  /* min-height: 200px !important; */\n}\n.tox-notification--warning {display: none !important;}\n.tox .tox-menu {z-index: 1200 !important;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
